/**
 * 前端环境配置
 */

// 开发环境配置
const development = {
  API_BASE_URL: 'https://dhszlib.com:3003/api',
  APP_NAME: '动画课程平台 (开发版)',
  VERSION: '1.0.0-dev',
  DEBUG: true
};

// 生产环境配置
const production = {
  API_BASE_URL: 'https://dhszlib.com:3003/api', // 生产环境可能使用不同的URL
  APP_NAME: '动画课程平台',
  VERSION: '1.0.0',
  DEBUG: false,
 
  // 文件上传API配置
  UPLOAD: {
    UPLOAD_URL: 'https://dhszlib.com:3003/api/files/upload',
    FILE_LIST_URL: 'https://dhszlib.com:3003/api/files/list',
    MAX_FILE_SIZE: 20 * 1024 * 1024, // 20MB
    ALLOWED_TYPES: '*'
  }
};

// 根据环境变量选择配置
const config = process.env.NODE_ENV === 'production' ? production : development;

export default config;